import { FieldArray, useFormikContext } from 'formik';
import Accordion from '../../../../components/Accordion/Accordion';
import Button from '../../../../components/Button/Button';
import { Menu, MenuItem } from '@mui/material';
import '../BackofficeMaterial.scss';
import Input from '../../../../components/Input/Input';
import TextArea from '../../../../components/TextArea/TextArea';
import { useState } from 'react';
import { ELanguages, TLanguages, languages } from '../../../localization';
import { IFormikBOM } from '../IBackofficeMaterial';
import { useTranslation } from 'react-i18next';
interface IFormikGeneralInfoProps {}

export const FormikGeneralInfo = (props: IFormikGeneralInfoProps) => {
    const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
    const open = Boolean(anchorEl);
    const { values, handleChange } = useFormikContext<IFormikBOM>();
    const languagesAvailable = Object.keys(ELanguages).filter(l => !values.infos.find(el => el.languageCodeISO === l));
    const { t } = useTranslation();

    return (
        <div className='w-25 d-flex flex-column gap-2'>
            <label className='py-3'> {t('bo_material_titles_gi')}</label>
            <FieldArray
                name='infos'
                render={arrayHelpers => (
                    <>
                        {values.infos.map((info, index) => {
                            const regionNamesInEnglish = new Intl.DisplayNames(info.languageCodeISO, { type: 'language' });
                            const language = regionNamesInEnglish.of(info.languageCodeISO);
                            return (
                                <div key={info.languageCodeISO}>
                                    {!!language && (
                                        <Accordion title={language}>
                                            <div className='d-flex flex-column gap-1'>
                                                <Input
                                                    type='text'
                                                    title={t('bo_material_input_name')}
                                                    name={`infos[${index}].name`}
                                                    onChange={handleChange}
                                                    className='d-flex flex-column'
                                                    value={info.name}
                                                />
                                                <TextArea title={t('bo_material_input_description')} name={`infos[${index}].description`} onChange={handleChange} rows={5} value={info.description} />
                                                <Button type='button' onClick={() => arrayHelpers.remove(index)} className='d-flex justify-content-end' classNameBtn='btn-color-icon-delete'>
                                                    <i className='fa-solid fa-trash' />
                                                </Button>
                                            </div>
                                        </Accordion>
                                    )}
                                </div>
                            );
                        })}
                        <Button className='d-flex justify-content-end pt-2' classNameBtn='btn-color-inverted' onClick={e => setAnchorEl(e.currentTarget)}>
                            <i className='fa-solid fa-plus' />
                        </Button>
                        <Menu
                            id='basic-menu-bo-material'
                            anchorEl={anchorEl}
                            open={open}
                            onClose={() => {
                                setAnchorEl(null);
                            }}
                            MenuListProps={{
                                'aria-labelledby': 'basic-button',
                            }}>
                            {languagesAvailable.map(l => (
                                <MenuItem
                                    key={l}
                                    onClick={() => {
                                        arrayHelpers.push({ languageCodeISO: l, name: '', description: '' });
                                    }}>
                                    {languages[l as TLanguages]}
                                </MenuItem>
                            ))}
                        </Menu>
                    </>
                )}
            />
        </div>
    );
};
